import { BookOpen, Compass, Target, ShieldCheck } from "lucide-react";
import Reveal from "./Reveal";
import CtaButton from "./CtaButton";

const TOPICS = [
    {
        no: "01",
        icon: BookOpen,
        tone: "text-lav",
        ring: "border-electric/30 bg-electric/10",
        blob: "bg-electric/10",
        title: "ENGULFING FUNDAMENTALS",
        body: "Understand the basics of bullish and bearish engulfing patterns.",
    },
    {
        no: "02",
        icon: Compass,
        tone: "text-neon",
        ring: "border-neon/30 bg-neon/10",
        blob: "bg-neon/10",
        title: "MARKET STRUCTURE",
        body: "Learn how to observe market direction and trading conditions.",
    },
    {
        no: "03",
        icon: Target,
        tone: "text-lav",
        ring: "border-electric/30 bg-electric/10",
        blob: "bg-electric/10",
        title: "ENTRY CONFIRMATION",
        body: "Explore how engulfing patterns can be evaluated alongside other analysis.",
    },
    {
        no: "04",
        icon: ShieldCheck,
        tone: "text-white",
        ring: "border-white/30 bg-white/10",
        blob: "bg-white/5",
        title: "RISK MANAGEMENT",
        body: "Understand the importance of stop loss, position sizing and managing trading risk.",
    },
];

const Modules = () => (
    <section data-testid="modules-section" className="relative py-24 md:py-32">
        <div className="pointer-events-none absolute left-0 top-1/3 h-[420px] w-[420px] rounded-full bg-electric/10 blur-3xl" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Reveal>
                <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-neon">
                    Kandungan webinar
                </p>
                <h2 className="mt-5 max-w-3xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-6xl">
                    WHAT WILL YOU LEARN?
                </h2>
            </Reveal>

            <div className="mt-14 grid gap-5 md:grid-cols-2">
                {TOPICS.map((m, i) => (
                    <Reveal key={m.no} delay={0.08 * i}>
                        <div
                            data-testid={`module-card-${i + 1}`}
                            className="card-luxe group relative h-full overflow-hidden rounded-3xl p-8 transition duration-300 hover:-translate-y-1 hover:border-neon/40 md:p-10"
                        >
                            <div
                                className={`pointer-events-none absolute -right-12 -top-12 h-40 w-40 rounded-full ${m.blob} blur-2xl transition duration-300 group-hover:scale-125`}
                            />
                            <div className="relative flex items-start justify-between">
                                <span
                                    className={`inline-flex rounded-2xl border p-3.5 ${m.ring}`}
                                >
                                    <m.icon size={24} className={m.tone} />
                                </span>
                                <span className="font-mono text-sm tracking-[0.2em] text-white/25">
                                    TOPIK_{m.no}
                                </span>
                            </div>
                            <h3 className="relative mt-8 font-display text-xl font-extrabold tracking-tight text-white md:text-2xl">
                                {m.title}
                            </h3>
                            <p className="relative mt-4 leading-relaxed text-white/65">
                                {m.body}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.1}>
                <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.18em] text-white/35">
                    *Topik adalah cadangan kandungan dan tertakluk kepada
                    pengesahan penganjur
                </p>
                <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
                    <CtaButton location="After Learning" testId="middle-cta-button">
                        PM Admin to Join
                    </CtaButton>
                </div>
            </Reveal>
        </div>
    </section>
);

export default Modules;
